import React from "react";
import PlataformaUnidadesPage from "../components/PlataformaUnidadesPage";
import { lcCreateUnidad, lcDeleteUnidad, lcListChipsDisponibles, lcListHwTypes, lcListIconLibrary, lcListUnidades, lcListUnitGroups, lcSyncUnidad, lcUpdateUnidad } from "../services/leasecontrolUsuarios.service";

export default function LeasecontrolUnidadesPage() {
  return (
    <PlataformaUnidadesPage
      title="Vehiculos / Unidades"
      subtitle="Modulo de LeaseControl"
      listUnits={lcListUnidades}
      listHwTypes={lcListHwTypes}
      listIconLibrary={lcListIconLibrary}
      listChips={lcListChipsDisponibles}
      listUnitGroups={lcListUnitGroups}
      createUnit={lcCreateUnidad}
      updateUnit={lcUpdateUnidad}
      deleteUnit={lcDeleteUnidad}
      syncUnit={lcSyncUnidad}
      providerColor="#006d75"
    />
  );
}
